import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class MatrixFormModel extends FormModel {

    @IsRequired()
    name: string

    constructor(initialData?: Partial<MatrixFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
